import Vue from 'vue'

import App from './App.vue'
import router from './router/index.js'
import store from "./store/index.js";
import VueWechatTitle from 'vue-wechat-title'
import './common'
import './assets/style/public.css';
import 'lib-flexible/flexible.js'

import {
  Button,NavBar,Icon,Divider,Stepper,Popup,Checkbox, CheckboxGroup,Field,Loading
} from 'vant';
import 'vant/lib/index.css';

// 按需引入vant组件 组件数组
let vantComponents = [Button,NavBar,Icon,Divider,Stepper,Popup,Checkbox, CheckboxGroup,Field,Loading];
vantComponents.forEach(e => {
  Vue.use(e);
});


 
 Vue.use(VueWechatTitle)
 Vue.config.productionTip = false
 
 // 全局过滤器
 Vue.filter('mobile', (phone) => (phone.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2")))
 Vue.filter('toCyScore', (cmccScore) => (Math.floor(cmccScore/120)*100))
 Vue.filter('toCmssScore', (cyScore) => (Math.ceil(cyScore*1.2)))

// 防抖处理-立即执行
const on = Vue.prototype.$on
Vue.prototype.$on = function (event, func) {
  let timer;
  let flag = true;
  let newFunc = func
  if (event == 'click') {
    newFunc = function () {
      if(flag) {
        func.apply(this, arguments)
        flag = false
      }
      clearTimeout(timer)
      timer = setTimeout(function () {
        flag = true
      }, 1000)
    }
  }
  on.call(this, event, newFunc)
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')



